<template>
  <div class="vx-col w-full">
    <vx-card title no-shadow card-border>
      <ValidationObserver ref="observer" v-slot="{}">
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/3" style="margin: 0.5rem 0">
                <vs-checkbox
                  class="mt-3"
                  v-model="plan.isPrepaid"
                  @change="handlePrepaidChange"
                  :disabled="
                    mode == 'view' ||
                    $route.query.mode == 'isBaseOverride' ||
                    $route.query.mode == 'base_override' ||
                    $route.query.mode == 'version_update'
                  "
                  >{{ $t("setup.label.IsPrepaid") }}
                </vs-checkbox>
              </div>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <div class="version-container">
              <div class="tag">
                {{ mode === "edit" ? "DRAFT" : selectedStatus }}
              </div>
              <div class="tag">
                {{ $t("setup.label.Version") }} :
                {{
                  selectedStatus === "ACTIVE" && mode === "edit"
                    ? plan.version + 1
                    : plan.version
                }}
              </div>
              <div
                class="tag-approval"
                v-if="selectedStatus === 'DRAFT' && mode === 'edit'"
                @click="makerCheckerApproval()"
              >
                {{ $t("setup.label.requestApproval") }}
              </div>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.PlanCode')"
            >
              <vs-input
                :label="$t('setup.label.PlanCode')"
                class="w-full mb-2 starlabel"
                v-model="plan.planCode"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full mb-4">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.PlanDescription')"
            >
              <vs-input
                :label="$t('setup.label.PlanDescription')"
                class="w-full mb-2 starlabel"
                :placeholder="$t('setup.label.Enter_Plan_Description')"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
                v-model="plan.planDescription"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.PlanType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.PlanType')"
              >
                <v-select
                  label="mCodeValue"
                  v-model="plan.planType"
                  :options="planTemplateData.planTypeData"
                  :reduce="(planType) => planType.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :disabled="
                    mode == 'view' ||
                    $route.query.mode == 'isBaseOverride' ||
                    $route.query.mode == 'base_override' ||
                    $route.query.mode == 'version_update'
                  "
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.Status")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="status"
                    >
                      <v-select
                        label="value"
                        v-model="plan.status"
                        :options="planTemplateData.planStatus"
                        :reduce="(status) => status.id"
                        placeholder="--Select One--"
                      >
                        <template v-slot:option="option">{{
                          option.value
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div> -->
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.PlanStartDate")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.PlanStartDate')"
              >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="plan.startDate"
                  :disabled-dates="{
                    to: new Date(new Date().toDateString()),
                  }"
                  :disabled="mode == 'view'"
                  class="mb-2"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.PlanEndDate")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.PlanEndDate')"
              >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="plan.endDate"
                  :disabled="mode == 'view'"
                  :disabled-dates="{
                    to: new Date(new Date().toDateString()),
                  }"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.BillType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.BillType')"
              >
                <v-select
                  :options="billType"
                  v-model="billTypes"
                  :disabled="true"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.BillFrequency")
                }}<span class="required"> *</span></small
              >
              <v-select
                label="chargeDescription"
                v-model="selectedBillFrequency"
                :options="getBillingFrequency"
                :reduce="(obj) => obj.id"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
                :placeholder="$t('placeholder.label.SelectOne')"
                :multiple="true"
                :taggable="true"
              >
                <template v-slot:option="option">{{
                  option.chargeDescription
                }}</template>
              </v-select>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.BillingRule")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.BillingRule')"
              >
                <v-select
                  label="billruleOptions"
                  v-model="plan.billRule"
                  :options="planTemplateData.billRuleDatas"
                  :reduce="(billRule) => billRule.id"
                  :disabled="
                    mode == 'view' ||
                    $route.query.mode == 'isBaseOverride' ||
                    $route.query.mode == 'base_override' ||
                    $route.query.mode == 'version_update' ||
                    plan.isPrepaid
                  "
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.billruleOptions
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div v-if="plan.isPrepaid || !plan.isPrepaid">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{
                    plan.isPrepaid
                      ? $t("setup.label.chargesperiodicity")
                      : $t("setup.label.contractduration")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Duration')"
                >
                  <v-select
                    label="subscriptionPeriod"
                    v-model="selectedDurations"
                    :options="planTemplateData.subscriptiondata"
                    :reduce="(planType) => planType.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :disabled="
                      mode == 'view' ||
                      $route.query.mode == 'isBaseOverride' ||
                      $route.query.mode == 'base_override' ||
                      $route.query.mode == 'version_update'
                    "
                    :multiple="true"
                    :taggable="true"
                  >
                    <template v-slot:option="option">{{
                      option.subscriptionPeriod
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.Currency")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Currency')"
              >
                <v-select
                  label="labelStr"
                  v-model="plan.currencyId"
                  :options="currencyOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(name) => name.id"
                  :disabled="
                    mode == 'view' ||
                    $route.query.mode == 'isBaseOverride' ||
                    $route.query.mode == 'base_override' ||
                    $route.query.mode == 'version_update'
                  "
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.labelStr
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("setup.label.ExternalPlanName")
              }}</small>
              <ValidationProvider
                rules=""
                v-slot="{ errors }"
                :name="$t('setup.label.ExternalPlanName')"
              >
                <v-select
                  label="pkg_name"
                  v-model="plan.externalPlanName"
                  :options="ExternalPlansList || []"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :disabled="
                    mode == 'view' ||
                    $route.query.mode == 'isBaseOverride' ||
                    $route.query.mode == 'base_override' ||
                    $route.query.mode == 'version_update'
                  "
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.ServiceCode")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ServiceCode')"
              >
                <v-select
                  :label="'serviceCode'"
                  v-model="serviceData"
                  :options="planTemplateData.services"
                  @input="onSelectService"
                  :disabled="
                    mode == 'view' ||
                    $route.query.mode == 'isBaseOverride' ||
                    $route.query.mode == 'base_override' ||
                    $route.query.mode == 'version_update'
                  "
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.serviceCode
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div
            v-if="mode == 'edit' || mode == 'create'"
            class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
          >
            <pick-file
              ref="fileUploadComponent"
              @fileUpdate="changeFile"
              :class="{ 'disabled-pickfile': isPickFileDisabled }"
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{ $t("setup.label.DC_Rule") }}</small>
              <v-select
                :label="'value'"
                v-model="dcRule"
                :options="dcRules"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(dcRule) => dcRule.id"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :taggable="true"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div>
          </div>
          <div
            class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
            v-if="planAttributeDatas"
          >
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("setup.label.PlanAttribute")
              }}</small>
              <v-select
                :label="'mCodeValue'"
                v-model="selectedAttribute"
                :options="planAttributeDatas"
                @input="getPlanAttributeValue"
                :placeholder="$t('placeholder.label.SelectOne')"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :multiple="true"
                :taggable="true"
                class="min-w-200 w-full mb-2"
              >
                <template v-slot:option="option">{{
                  option.mCodeValue
                }}</template>
              </v-select>
            </div>
          </div>

          <!-- <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full">
                      <div class="vx-row">
                        <div class="vx-col lg:w-1/2 md:w-1/2">
                          <div class="vx-col w-full pt-2" style="margin: 0.5rem 0">
                            <vs-checkbox
                              class="mt-2"
                              v-model="isProvision"
                              :disabled="
                                mode == 'view' ||
                                $route.query.mode == 'isBaseOverride' ||
                                $route.query.mode == 'base_override' ||
                                $route.query.mode == 'version_update'
                              "
                              >{{ $t("setup.label.IsProvision") }}</vs-checkbox
                            >
                          </div>
                        </div>
                      </div>
                    </div> -->

          <!-- <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.Status")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="status"
                    >
                      <v-select
                        label="value"
                        v-model="plan.status"
                        :options="planTemplateData.planStatus"
                        :reduce="(status) => status.id"
                        placeholder="--Select One--"
                      >
                        <template v-slot:option="option">{{
                          option.value
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div> -->

          <div
            v-for="(attr, i) in selectedAttribute"
            v-if="selectedAttribute.length"
            :key="attr.id"
            class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-full xs:w-full"
          >
            <div class="dropdown-with-label">
              <small class="date-label">{{ attr.mCodeValue }}</small>
              <v-select
                :label="'mCodeValue'"
                v-model="selectedAttributeValues[i]"
                :options="planAttributeValueDatas"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
                :reduce="(obj) => obj.mCodeValue"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :multiple="false"
                :taggable="true"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div>
          </div>
        </div>
        <div
          class="vx-row mt-5"
          v-if="
            mode != 'view' &&
            serviceObject &&
            serviceObject.products &&
            serviceObject.products.length > 0
          "
        >
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:1/2 xs:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.ProductCode")
                }}<span class="required"> *</span></small
              >
              <v-select
                label="productCode"
                v-model="selectedProduct"
                :options="serviceObject.products"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:1/2 xs:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label">
                {{ $t("setup.label.ExternalProductName") }}
                <span class="required"> *</span>
              </small>
              <v-select
                label="product_name"
                v-model="selectedExternalProductId"
                :disabled="
                  mode == 'view' ||
                  $route.query.mode == 'isBaseOverride' ||
                  $route.query.mode == 'base_override' ||
                  $route.query.mode == 'version_update'
                "
                :options="productOptions || []"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-1/3 xs:w-w-1/3">
            <vs-button
              :disabled="
                (!serviceObject.products.length && addedProducts.length) ||
                !selectedProduct ||
                mode == 'view'
              "
              icon-pack="feather"
              icon="icon-plus"
              @click="addProduct"
              color="success"
              class="mt-4"
              size="small"
              >{{ $t("setup.label.AddProducts") }}</vs-button
            >
          </div>
        </div>
        <div
          v-if="
            addedProducts &&
            addedProducts.length > 0 &&
            !(
              addedProducts.length === 1 &&
              addedProducts[0].product === null &&
              addedProducts[0].externalId === null
            )
          "
          class="mt-2"
        >
          <vs-table :data="addedProducts" stripe>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.ProductCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.ExternalProductName") }}</vs-th>
              <vs-th v-if="mode != 'view'">{{
                $t("setup.label.Actions")
              }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(product, ind) in data" :key="ind">
                <vs-td>
                  {{ product.product && product.product.productCode }}
                </vs-td>
                <vs-td>
                  {{
                    product &&
                    product.product &&
                    product.product.externalProductName
                      ? product &&
                        product.product &&
                        product.product.externalProductName
                      : product.externalId && product.externalId.product_name
                  }}
                </vs-td>
                <vs-td v-if="mode != 'view'">
                  <vs-button
                    color="danger"
                    icon-pack="feather"
                    icon="icon-trash"
                    class="mb-2"
                    size="small"
                    @click="removeProduct(product, ind)"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:1/2 xs:w-1/2"></div>
          </div>
        </div>
        <div
          class="vx-row"
          v-for="(dis, ind) in addedDiscounts"
          :key="dis.discountId"
        >
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-1/2 xs:w-1/2">
            <h4 class="mt-2">
              <feather-icon
                icon="PercentIcon"
                :title="$t('setup.label.Edit')"
                svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                class="icon_row"
              />
              {{ dis.discountName }}
              <feather-icon
                class="ml-4 icon_row cursor-pointer"
                icon="TrashIcon"
                :title="$t('setup.label.Delete')"
                :disabled="mode == 'view'"
                svgClasses="w-5 h-5 text-danger stroke-current cursor"
                @click="removeDiscount(dis, ind)"
              />
            </h4>
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-1/2 xs:w-1/2">
            <div class="vx-row">
              <div class="vx-col w-full lg:w-2/3 md:w-2/3 sm:w-2/3 xs:w-2/3">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("setup.label.DiscountCode")
                    }}<span class="required"> *</span></small
                  >
                  <v-select
                    :label="`discountName`"
                    v-model="addedDiscounts[ind]"
                    :options="allDiscounts"
                    @input="(val) => onChangeDiscount(val, ind)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :disabled="mode == 'view'"
                  >
                    <template v-slot:option="option">{{
                      option.discountName
                    }}</template>
                  </v-select>
                </div>
              </div>
              <div
                class="vx-col w-full lg:w-1/3 md:w-1/3 sm:w-1/3 xs:w-1/3"
              ></div>
            </div>
          </div>
        </div>
        <div class="vx-row center my-5">
          <div class="vx-col w-full">
            <!-- <vs-button
                        color="primary"
                        type="border"
                        class="footerButton-cancel"
                        @click="cancel"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      > -->
            <vs-button
              v-if="!id"
              class="mr-3 mb-37 footerButton-next"
              @click="createplan"
              >{{ $t("setup.label.SaveAndContinue") }}</vs-button
            >
            <vs-button
              v-else
              v-show="mode != 'view'"
              class="mr-3 mb-37 footerButton-next"
              @click="editPlan"
              >{{ $t("setup.label.SaveAndContinue") }}</vs-button
            >
          </div>
        </div>
      </ValidationObserver>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('setup.label.AdvanceView')"
          :active.sync="userChangePassword"
          class="popup-close"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full sm:w-full xs:w-full">
                <vs-input
                  :label="$t('setup.label.Name')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="name"
                />
              </div>
              <div class="vx-col w-full sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("system.label.Enabled") }}
                    <span class="required"> *</span></small
                  >
                  <v-select
                    :options="enabledOptions"
                    v-model="enabled"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="vx-row" style="display: flex; justify-content: center">
              <span class="ml-4 mr-1">
                <vs-button type="border" @click="userChangePassword = false">{{
                  $t("system.label.cancel")
                }}</vs-button>
              </span>
              <span class="ml-1 mr-2">
                <vs-button
                  icon-pack="feather"
                  icon="icon-check"
                  @click="savePasswordChange(passwordId)"
                  >{{ $t("system.label.submit") }}</vs-button
                >
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
    </vx-card>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { setHeader, removeHeader } from "@/http";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import { mapState } from "vuex";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const planEmptyObj = {
  planType: "",
  locale: "en",
  dateFormat: "dd MMMM yyyy HH:mm:ss",
  endDate: "",
  serviceId: "",
  isAdvance: false,
  isPrepaid: false,
  billRule: "",
  currencyId: "",
  externalPlanId: "",
  externalPlanName: "",
  durations: "",
  planCode: "",
  billfrequency: "",
  planDescription: "",
  provisioingSystem: "None",
  startDate: moment().format("DD MMMM yyyy HH:mm:ss"),
  version: 1,
};
export default {
  props: {
    mode: String,
    planId: Number,
    routeId: Number,
    planName: String,
    planVersion: Number,
  },
  components: {
    FormWizard,
    TabContent,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
    "v-select": vSelect,
    Multiselect,
  },
  data() {
    return {
      planType: "",
      activeTab: 0,
      selectedStatusId: 0,
      locale: "en",
      dateFormat: "dd MMMM yyyy HH:mm:ss",
      endDate: "",
      billType: ["Advance", "Arrear"],
      selectedBillFrequency: [],
      selectedDurations: [],
      selectedAttributeValues: [],

      dcRule: "",
      serviceId: "",
      billTypes: "Arrear",
      billfrequency: "",
      durations: "",
      isAdvance: false,
      isPrepaid: false,
      products: [],
      status: "DRAFT",
      billRule: "",
      currencyId: "",
      externalPlanId: "",
      externalPlanName: "",
      duration: "",
      planCode: "",
      planDescription: "",
      units: 0,
      volume: "None",
      provisioingSystem: "None",
      startDate: moment().format("dd MMMM yyyy"),
      //
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      // plan: planEmptyObj,
      planTypes: ["Pay", "FTA"],
      broadcasters: [],
      planCategorys: [],
      serviceData: "",
      serviceCode: "",
      addedProducts: [{ product: null, externalId: null }],
      productsShow: false,
      selected: "",
      isProvision: true,
      availableproductsX: [],
      availableproducts: [],
      availableChannels: [],
      services: [],
      selectedProducts: [],
      selectedUserIds: [],
      id: "",
      check: 0,
      allDiscounts: [],
      serviceObject: {},
      productsOfService: [],
      selectedProduct: "",
      selectedDiscount: "",
      addedDiscounts: [],
      selectedExternalProductId: "",
      planAttributes: [],

      //
      selectedRuleType: "",
      plansByRule: {},
      selectedSourcePlan: null,
      selectedTargetPlan: null,
      name: "",
      selectedAttribute: [],
      enabledOptions: [true, false],
      enabled: false,
      userChangePassword: false,
      isPickFileDisabled: false,
      plan: { ...planEmptyObj },
      bulkUploads: {
        file: null,
      },
    };
  },

  computed: {
    ...mapState({
      planTemplateData: (store) => store.planPrice.planTemplateData,
      planAttributeDatas: (store) => store.planPrice.planAttribute,
      planAttributeValueDatas: (store) => store.planPrice.planAttributeValue,
      planWithTempate: (state) => state.planPrice.planWithTempate,
      ExternalPlansList: (store) => store.planPrice.externalPlans,
      getBillingFrequency: (store) => store.chargecode.list,
      dcRules: (store) => store.planPrice.dcRules,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    productOptions() {
      if (this.ExternalPlansList) {
        const id =
          this.plan && this.plan.externalPlanName.pkg_id
            ? this.plan && this.plan.externalPlanName.pkg_id
            : this.plan.externalPlanId;
        const selectedPlan = this.ExternalPlansList.find(
          (plan) => plan.pkg_id === id
        );
        return selectedPlan ? selectedPlan.productList : [];
      } else return [];
    },
    currencyOptions() {
      if (this.planTemplateData && this.planTemplateData.currencydata) {
        return this.planTemplateData.currencydata.currencyOptions.map((el) => {
          return {
            ...el,
            labelStr: `${el.code}--${el.name}`,
          };
        });
      } else {
        return [];
      }
    },
    selectedStatus() {
      if (this.planTemplateData && this.planTemplateData.planStatus) {
        const statusObj = this.planTemplateData.planStatus.find(
          (item) => item.id === this.selectedStatusId
        );
        return statusObj ? statusObj.value : "N/A";
      }
    },
    selectedDiscountId() {
      let arr = [];
      if (this.addedDiscounts && this.addedDiscounts.length) {
        this.addedDiscounts.forEach((el) => arr.push(el.discountId));
      }
      return arr;
    },
  },

  methods: {
    setAttributes(fieldName, value) {
      if (!value) return;
      //   this.selectedAttribute = [];
      for (const attr of this.planAttributes) {
        if (attr.attributeName === fieldName) {
          attr.attributeValue = value;
          return;
        }
      }

      // Add new attribute if it doesn't exist
      this.planAttributes.push({
        attributeName: fieldName,
        attributeValue: value,
      });
      this.selectedAttribute = this.planAttributeDatas.filter((el) =>
        this.planAttributes.find((attr) => {
          el.value = attr.attributeValue;
          return attr.attributeName === el.mCodeValue;
        })
      );
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    reformatDate(val) {
      let date = "";
      if (val) {
        let years1 = val[0];
        let months1 = val[1];
        let date1 = val[2];
        date = months1 + " " + date1 + " " + years1;
      }
      return date;
    },
    async getPlanTemplate() {
      try {
        await this.$store.dispatch("planPrice/setPlanTemplateData");
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async getPlanAttribute() {
      try {
        await this.$store.dispatch("planPrice/setPlanAttributes");
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async makerCheckerApproval() {
      try {
        this.$swal({
          title: "Do you want to send approval request?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.sendApproval();
              this.$router.push(`/setup/plan-pricing`);
            } catch (error) {
              this.$toasted.error("something went wrong!!");
            }
          }
        });
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async sendApproval() {
      try {
        await this.$store.dispatch("planPrice/sendApprovalAction", this.id);
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Approval request sent!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async getPlanData() {
      try {
        await this.$store.dispatch("planPrice/getPlanById", this.id);
        this.$store.dispatch("planPrice/fetchAttachmentAction", this.id);
        this.plan.isPrepaid =
          this.planWithTempate.isPrepaid == "N" ? false : true;
        this.plan.planCode = this.planWithTempate.planCode;
        this.plan.planDescription = this.planWithTempate.planDescription;
        if (this.plan.isPrepaid !== "N" && this.planWithTempate.duration)
          this.duration = parseInt(this.planWithTempate.duration);
        this.plan.startDate = this.getDate(this.planWithTempate.startDate);
        this.plan.endDate = this.getDate(this.planWithTempate.endDate);
        this.plan.planType = this.planWithTempate.planType;
        this.selectedStatusId = this.planWithTempate.status;
        this.plan.version = this.planWithTempate.version;
        this.plan.billRule = this.planWithTempate.billRule;
        this.planAttributes =
          (this.planWithTempate &&
            this.planWithTempate.selectedPlanAttributes) ||
          [].map();
        this.selectedAttribute = this.planAttributeDatas.filter((el) =>
          this.planAttributes.find((attr) => {
            el.value = attr.attributeValue;
            this.selectedAttributeValues.push(attr.attributeValue);
            return attr.attributeName === el.mCodeValue;
          })
        );

        this.selectedBillFrequency =
          this.planWithTempate.billfrequencyValues.map(Number);
        this.selectedDurations =
          this.planWithTempate.durationsValues.map(Number);
        // this.isAdvance = this.planWithTempate.selectedPlanAttributes
        //   ? true
        //   : false;
        this.billTypes =
          this.planWithTempate.isAdvance == false ? "Arrear" : "Advance";
        this.dcRule = parseInt(this.planWithTempate.disconnectionCreditRule);
        this.plan.currencyId = this.planWithTempate.currencyId;
        this.plan.externalPlanName = this.planWithTempate.externalPlanName;
        this.plan.externalPlanId = String(this.planWithTempate.externalPlanId);
        // this.isProvision =
        //   this.planWithTempate.provisionSystem == "Provision" ? true : false;
        //
        this.planWithTempate.selectedProducts[0].serviceId;
        this.serviceData = this.planTemplateData.services.find(
          (el) => el.id == this.planWithTempate.selectedProducts[0].serviceId
        );
        // products

        this.productsOfService = this.planTemplateData.products.filter(
          (el) => el.serviceId == this.serviceData.id
        );

        this.serviceObject = {
          ...this.serviceData,
          products: this.planWithTempate.products,
        };
        this.addedProducts = this.planWithTempate.selectedProducts.map((e) => ({
          product: e,
          externalId: e.externalProductId,
          externalName: e.externalProductName,
        }));

        // this.addedDiscounts = this.planWithTempate.selectedDiscounts.map(
        //   (discount) => ({
        //     discountId: discount.id,
        //     discountName: discount.name,
        //     discountCode: discount.code,
        //   })
        // );
        // selectedDiscounts not available in api
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async editPlan() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (this.addedProducts.length == 0) {
        this.warningPopup = true;
        this.warningText = "Please add atleast one product";
        return;
      }
      this.plan.startDate = moment(this.plan.startDate).format(
        "DD MMMM yyyy HH:mm:ss"
      );
      this.plan.endDate = moment(this.plan.endDate).format(
        "DD MMMM yyyy HH:mm:ss"
      );
      for (let temp of this.services) {
        if (temp.serviceCode == this.serviceCode) {
          this.plan.serviceId = temp.id;
        }
      }
      this.plan.productList = this.addedProducts.map((product) => ({
        productId: product.product.id,
        extProductId:
          (product.externalId && product.externalId.product_id) ||
          product.externalId ||
          null,
        externalProductName:
          (product.externalId && product.externalId.product_name) || null,
      }));

      this.plan.provisioingSystem = this.isProvision ? "Provision" : "None";
      if (this.plan.externalPlanName) {
        this.plan.externalPlanName = this.plan.externalPlanName.pkg_name;
        const externalPlan = this.ExternalPlansList.find(
          (el) => el.pkg_name === this.plan.externalPlanName
        );
        if (externalPlan) {
          this.plan.externalPlanId = externalPlan.pkg_id;
        }
      }
      this.plan.isAdvance = this.billTypes == "Advance" ? true : false;
      const attributes = [];
      for (let i = 0; i < this.selectedAttribute.length; i++) {
        attributes.push({
          attributeName: this.selectedAttribute[i].mCodeValue,
          attributeValue: this.selectedAttributeValues[i],
        });
      }
      const payload = {
        ...this.plan,
        status: 0,
        version: this.plan.version,
        isBaseOverride: false,
        planAttributes: attributes,
        planDiscounts: this.selectedDiscountId,
        disconnectionCreditRule: this.dcRule,
        dateFormat: "dd MMMM yyyy HH:mm:ss",
        locale: "en",
      };
      delete payload.selectedStatusId;
      // if (this.externalPlanName) {
      //   payload.externalPlanId = this.externalPlanName.pkg_id || this.externalPlanId;
      //   payload.externalPlanName =
      //     this.externalPlanName.pkg_name || this.externalPlanName;
      // }
      if (this.$route.query.mode == "version_update") {
        payload.saveAsVersionUpdate = true;
      }
      if (this.$route.query.mode == "base_override") {
        payload.saveAsBaseOverride = true;
      }
      // if (!this.$route.query.mode) {
      //   payload.isBaseOverride = false;
      // }
      // payload.version = this.planWithTempate.version;
      // if (this.planWithTempate.version == "") {
      //   payload.version = this.planWithTempate.version;
      // }

      // if (this.plan.externalPlanId) {
      //   this.plan.externalPlanId = this.plan.externalPlanId.pkg_id;
      //   this.plan.externalPlanName = this.plan.externalPlanId.pkg_name;
      // }

      payload.productList = this.addedProducts.map((product) => ({
        productId: product.product.id,
        extProductId:
          (product.externalId && product.externalId.product_id) ||
          product.externalId ||
          null,
        externalProductName: product.externalId
          ? product.externalId.product_name || product.externalName
          : null,
      }));
      if (this.isPrepaid) {
        // payload.duration = this.duration;
      }
      try {
        await this.$store.dispatch("planPrice/updatePlanAction", {
          id: this.id,
          data: payload,
        });
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Plan Edited Successfully!",
          type: "success",
        });
        this.$emit("completed");
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    onSelectService(val) {
      this.serviceObject = {};
      this.productsOfService = this.planTemplateData.products.filter(
        (el) => el.serviceId == val.id
      );
      if (this.planWithTempate.selectedProducts) {
        this.addedProducts = [...this.planWithTempate.selectedProducts];
        this.addedProducts = this.planWithTempate.selectedProducts.map((e) => ({
          product: e,
          externalId: e.externalProductId,
          externalName: e.externalProductName,
        }));
      } else {
        this.addedProducts = [];
      }
      this.serviceObject = {
        ...val,
        products: this.productsOfService.filter(
          (product) =>
            !this.addedProducts.some(
              (addedProduct) => addedProduct.id === product.id
            )
        ),
      };
    },
    addService() {
      if (Object.keys(this.serviceData).length)
        this.serviceObject = {
          ...this.serviceData,
          products: [...this.productsOfService],
        };
    },
    onChangeProduct() {
      const addedProductIds = new Set(
        this.addedProducts.map((product) => product.id)
      );
      this.serviceObject.products = this.productsOfService.filter(
        (product) => !addedProductIds.has(product.id)
      );
    },
    async callPriceTemplate() {
      try {
        await this.$store.dispatch("chargecode/setEntities");
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async createplan() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      if (this.addedProducts.length == 0) {
        this.warningPopup = true;
        this.warningText = "Please add atleast one product";
        return;
      }
      this.plan.startDate = moment(this.plan.startDate).format(
        "DD MMMM yyyy HH:mm:ss"
      );
      this.plan.endDate = moment(this.plan.endDate).format(
        "DD MMMM yyyy HH:mm:ss"
      );
      for (let temp of this.services) {
        if (temp.serviceCode == this.serviceCode) {
          this.plan.serviceId = temp.id;
        }
      }
      this.plan.productList = this.addedProducts.map((product) => {
        return {
          productId: product.product.id,
          extProductId:
            (product.externalId && product.externalId.product_id
              ? product.externalId && product.externalId.product_id
              : product.externalId && product.externalId.produc_tid) || null,
          externalProductName:
            (product.externalId && product.externalId.product_name) || null,
        };
      });
      this.plan.provisioingSystem = this.isProvision ? "Provision" : "None";
      if (this.plan.externalPlanName) {
        this.plan.externalPlanName = this.plan.externalPlanName.pkg_name;
        const externalPlan = this.ExternalPlansList.find(
          (el) => el.pkg_name === this.plan.externalPlanName
        );
        if (externalPlan) {
          this.plan.externalPlanId = externalPlan.pkg_id;
        }
      }
      this.plan.billRule =
        this.plan.isPrepaid === true
          ? this.plan.billRule.id
          : this.plan.billRule;
      this.plan.isAdvance = this.billTypes == "Advance" ? true : false;
      this.planAttributes = [];
      for (let i = 0; i < this.selectedAttributeValues.length; i++) {
        this.planAttributes.push({
          attributeName: this.selectedAttribute[i].mCodeValue,
          attributeValue: this.selectedAttributeValues[i],
        });
      }
      const payload = {
        ...this.plan,
        status: 0,
        version: this.plan.version,
        isBaseOverride: false,
        planAttributes: this.planAttributes,
        disconnectionCreditRule: this.dcRule,
        planDiscounts: this.selectedDiscountId,
        dateFormat: "dd MMMM yyyy HH:mm:ss",
        locale: "en",
      };
      try {
        const resp = await this.$store.dispatch(
          "planPrice/createPlanAction",
          payload
        );
        if (this.bulkUploads.file) {
          let formData = new FormData();
          setHeader("Content-Type", "multipart/form-data");
          formData.append("name", "attachment");
          formData.append("file", this.bulkUploads.file);
          removeHeader("Content-Type");
          await this.$store.dispatch("planPrice/uploadAttachmentAction", {
            id: resp.data.resourceId,
            data: formData,
          });
        }
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Plan Created Successfully!",
          type: "success",
        });
        this.id = resp.data.resourceId;
        const buttons = document.querySelectorAll(".vs-tabs--li button");
        for (const b of buttons) {
          b.disabled = false;
        }
        this.$emit("completed", this.id);
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    addProduct() {
      if (!this.selectedProduct) return;
      if (
        !this.addedProducts.some(
          (el) => el.product.id === this.selectedProduct.id
        )
      ) {
        this.addedProducts.push({
          product: this.selectedProduct,
          externalId: this.selectedExternalProductId,
        });
      }
      this.serviceObject.products = this.serviceObject.products.filter(
        (product) =>
          !this.addedProducts.some(
            (addedProduct) => addedProduct.product.id === product.id
          )
      );
      this.selectedProduct = null;
      this.selectedExternalProductId = null;
    },
    removeProduct(product, ind) {
      this.addedProducts.splice(ind, 1);
    },
    async getExternalPlansMethod() {
      try {
        await this.$store.dispatch("planPrice/getExternalPlansAction");
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Unable To Fetch Enternal Plans!",
          type: "error",
        });
      }
    },

    dateFormatt(val) {
      let month = monthNames[val.getMonth()];
      return (
        val.getDate() +
        " " +
        month +
        " " +
        val.getFullYear() +
        " " +
        val.getHours() +
        ":" +
        val.getMinutes() +
        ":" +
        val.getSeconds()
      );
    },
    async changeFile(file) {
      this.bulkUploads.file = file;
    },
    handlePrepaidChange() {
      if (this.plan.isPrepaid) {
        this.plan.isPrepaid = true;
        this.billTypes = "Advance";
        this.plan.billRule = {
          billruleOptions: "No Prorata",
          id: 300,
          value: "No Prorata",
        };
      } else {
        this.billTypes = "Arrear";
        this.plan.billRule = "";
      }
    },
    async getPlanAttributeValue() {
      try {
        await this.$store.dispatch("planPrice/setPlanAttributesValue");
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    resetForm() {
      this.plan = {
        isPrepaid: false,
        isAdvance: false,
        durations: null,
        planCode: "",
        billfrequency: "",
        planDescription: "",
        planType: null,
        startDate: moment().format("DD MMMM yyyy HH:mm:ss"),
        endDate: null,
        billRule: null,
        currencyId: null,
      };
      this.serviceData = null;
      this.selectedProduct = null;
      this.addedProducts = [];
      this.serviceObject = {};
      this.isProvision = true;
      // Reset file upload
      this.$refs.fileUploadComponent.bulkUploads.file = null;
      this.$refs.fileUploadComponent.fileStatus = "No File Selected";
      const fileInput =
        this.$refs.fileUploadComponent.$el.querySelector("input[type='file']");
      if (fileInput) {
        fileInput.value = null;
      }
      this.$refs.observer.reset();
    },
  },
  watch: {
    serviceData(val) {
      this.availableproductsX = [];
      this.selectedProducts = [];
      if (val != null) {
        this.productsShow = true;
        this.serviceCode = val.serviceCode;
        this.availableproductsX = this.availableproducts.filter(
          (product) => product.serviceCode === this.serviceCode
        );
      } else {
        this.productsShow = false;
        this.serviceCode = "";
      }
    },
    selectedBillFrequency: {
      handler(newVal) {
        this.plan.billfrequency = newVal.join(",");
      },
      deep: true,
    },
    selectedDurations: {
      handler(newVal) {
        this.plan.durations = newVal.join(",");
      },
      deep: true,
    },
    isAdvance: {
      handler(newVal) {
        this.billTypes = newVal ? "Advance" : "Arrear";
      },
      deep: true,
    },
    planTemplateData(val) {
      this.availableproducts = val.products;
      this.services = val.services;
    },
    startDate(val) {
      this.plan.startDate = moment(val).format("DD MMMM yyyy HH:mm:ss");
    },
    endDate(val) {
      this.plan.endDate = this.dateFormatt(val);
    },
    isProvision(val) {
      this.plan.provisioingSystem = val ? "Provision" : "None";
    },
  },

  async mounted() {
    this.loading = true;
    this.$store.dispatch("planPrice/fetchDcRules");
    this.planWithTempate.selectedProducts = [];
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    this.routedFrom = this.$route.query.from || "";
    this.approvalId = this.$route.query.approvalId || "";
    this.callPriceTemplate();
    this.getPlanAttribute();
    if (
      this.$route.query.mode == "isBaseOverride" ||
      this.$route.query.mode == "base_override" ||
      this.$route.query.mode == "version_update"
    ) {
      this.$refs.fileUploadComponent.$el.querySelector(
        'input[type="file"]'
      ).disabled = true;
      this.isPickFileDisabled = true;
    }
    await this.getPlanTemplate();
    if (this.id) {
      await this.getPlanData();
    }
    this.getExternalPlansMethod();
    this.getPlanAttributeValue();
    this.$emit(
      "setPlanData",
      this.selectedStatus,
      this.plan.version,
      this.plan.planCode
    );
    this.loading = false;
  },
};
</script>
<style scoped>
::v-deep .vs__selected-options {
  padding: 8px 2px 2px 2px !important;
}
.disabled-pickfile {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
.mb-37 {
  margin-bottom: 37px !important;
}
</style>
